// PendingButton — save local in-progress work and return to the platform
// dashboard without releasing or committing the SecPose lease.

import * as React from 'react';
import { Button } from '../../components/ui/button';
import { t } from '../../config/strings';
import { saveDraft } from '../../lib/draft';
import { useStore } from '../../store';

export interface PendingButtonProps {
  onPending: () => void | Promise<void>;
}

export function PendingButton({ onPending }: PendingButtonProps): React.ReactElement {
  const hasFolder = useStore((s) => s.folder !== null);
  const [busy, setBusy] = React.useState(false);

  const handleClick = async (): Promise<void> => {
    setBusy(true);
    try {
      await saveDraft(useStore.getState());
      await onPending();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outline"
      className="w-full"
      disabled={!hasFolder || busy}
      onClick={handleClick}
      data-testid="pending-button"
    >
      {busy ? t.pending.saving : t.pending.pending}
    </Button>
  );
}
